<template lang="html">
   <div class="test-form">
      <div class="my-5 row justify-content-md-center" style="margin: 0">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9">
            <!-- <Form 
               class_binding="row" 
               v-bind="Product.forms.add_user"
               :ref="Product.forms.add_user.name"
               :form_data="Product.forms.add_user.data"
               @button-click="clickButton"
               @file-selected="uploadFile"
            /> -->

            <Form 
               class_binding="row" 
               :ref="Product.forms.select_form.name"
               :forms="Product.forms.select_form.forms"
               :form_data="Product.forms.select_form.data"
            />

            <div class="btns clearfix">
               <div class="btn btn-primary btn-r" @click="saveData({ref: $refs[Product.forms.select_form.name]})" :disabled="loading">
                  Click Me <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('product')
   },
   created(){
      utils.registerModule('product',product,this.$store)
   },
   components:{
      Form: () => import("clarks/components/form"),
   },
   computed: {
      ...mapGetters([
         'Product',
         'loading',
         'products'
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'saveData',
      ]),
      async clickButton(e){
         if(e.name === 'submit'){
            if(await e.ref.isValid()){
               $notify('success','Valid Form', 'Form is valid',20)
            }
         }
      },
      uploadFile(e){
         console.log('Name',e)
      }
   },
   mounted(){
      console.log('This is the env: ',process.env.VUE_APP_ENVIRONMENT,process.env.NODE_ENV)
      utils.registerModule('product',product,this.$store)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>